import Rest from '../Rest';

export default class IntegrationService extends Rest {

    static resource = '/integrations';
    
    async createIntegration(integrationData) {
	
		return await this.post(`/`, integrationData);

    }

    async update(integrationData, integrationId) {
	
		return await this.put(`/${integrationId}`, integrationData);

    }

    async deleteIntegration(integrationId) {
	
		return await this.delete(`/${integrationId}`);

    }

    async syncIntegration(integrationsToSync) {
	
		return await this.post(`/sync`, integrationsToSync);

    }

    async getIntegrations() {

        const filter = [{property:'active',operator:'=',value: true,}];
	
		return await this.get(`/?filter=${JSON.stringify(filter)}`);

    }

    async getIntegrationPaymentUrl() {

        return await this.get(`/paymentUrl`);

    }
    
}